import { useCallback, useContext } from 'react';
import { CopyToClipboardConfigContext } from './copy-to-clipboard-config-context';

export interface UseCopyToClipboardOptions {
  onCopySuccess?: () => void;
}

export const useCopyToClipboard = (options?: UseCopyToClipboardOptions) => {
  const config = useContext(CopyToClipboardConfigContext);
  const onCopySuccess = options?.onCopySuccess ?? config.onCopySuccess;

  const handleCopy = useCallback(
    (textToCopy: string) => {
      navigator.clipboard.writeText(textToCopy);
      onCopySuccess?.();
    },
    [onCopySuccess]
  );

  return { handleCopy };
};
